module.exports = __webpack_public_path__ + "img/zoom-in.45277fe9.png";